import { RootState } from "../store";

export const selectAttachmentsByQuestion = (state: RootState) => state.attachment.attachmentsByQuestion;

export const selectAttachmentsLoading = (state: RootState) => state.attachment.loading;

export const selectAttachmentsError = (state: RootState) => state.attachment.error;

export const selectCurrentAttachmentInspectionId = (state: RootState) => state.attachment.currentInspectionId;

export const selectViewingAttachments = (state: RootState) => state.attachment.viewingAttachments;

export const selectAttachmentCountForQuestion = (questionId: string) => (state: RootState) => {
    const attachments = state.attachment.attachmentsByQuestion[questionId];
    return attachments?.length || 0;
};
